import { render, staticRenderFns } from "./PixelRender.vue?vue&type=template&id=ec9d45c2"
import script from "./PixelRender.vue?vue&type=script&lang=js"
export * from "./PixelRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports